"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M5.2577 19.828c-.3695-.4105-.3362-1.0428.0743-1.4123l7.0408-6.3367L5.332 5.7423c-.4105-.3694-.4438-1.0017-.0743-1.4122.3695-.4105 1.0017-.4438 1.4123-.0744l7.8666 7.08c.4414.3973.4414 1.0894 0 1.4866l-7.8666 7.08c-.4106.3695-1.0428.3362-1.4123-.0743ZM18 4c-.5523 0-1 .4477-1 1v14c0 .5523.4477 1 1 1s1-.4477 1-1V5c0-.5523-.4477-1-1-1Z", clipRule: "evenodd" })), 'ArrowLastIcon');
